module.exports = __webpack_public_path__ + "static/media/boldredphoto.38d7699b.jpg";